import { makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import MessagesContext from '../../contexts/messagesContext';
const styles = makeStyles({
    title: {
        display: 'flex',
        alignItems: 'center',
        '& > span': {
            fontFamily: 'inherit',
            fontSize: '18px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.72',
            letterSpacing: 'normal',
            color: '#232733'
        },
        '& span:last-child': {
            marginInlineStart: '5px',
            fontSize: '14px',
            fontWeight: 'normal'
        }
    }
});
const PatientHeader = () => {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const total = useSelector((state) => state.patient.allPatients.total);
    return (
        <>
            <div className={classes.title}>
                <span> {messages.listOfPatients}</span>
                {total ? (
                    <span>
                        ({total} {messages.patient})
                    </span>
                ) : null}
            </div>
        </>
    );
};

export default PatientHeader;
